import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useTaxonomyContext } from '../../contexts/TaxonomyContext';

import { DataItem } from './DataItem';

import { useAuth } from '@/contexts/AuthContext';

const hiddenAttributes = [
  'seo_content',
  'seo_content_default',
  'itens_details',
  'items_details',
  'pairs_with',
];

const prioritizedKeys = [
  'design_features',
  'prints_and_colors',
  'sales_support',
];

export function DataList() {
  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'pages.VisionProduct.components.Attribute',
  });

  const { user } = useAuth();

  const customerLanguage = user?.customer.language
    .split('-')
    .shift()
    ?.toLowerCase();

  const attributesKeyTexts = {
    design_features: t('designFeatures', {
      lng: customerLanguage,
      fallbackLng: i18n.language,
    }),
    prints_and_colors: t('printsAndColors', {
      lng: customerLanguage,
      fallbackLng: i18n.language,
    }),
    sales_support: t('salesSupport', {
      lng: customerLanguage,
      fallbackLng: i18n.language,
    }),
    size_and_measurements: t('sizeAndMeasurements', {
      lng: customerLanguage,
      fallbackLng: i18n.language,
    }),
  };

  const { properties, propertiesLoading } = useTaxonomyContext();

  const sortedAttributes = Object.entries(properties)
    .filter(([, value]) => !hiddenAttributes.includes(value.type))
    .map(([key, value]) => {
      const priority = prioritizedKeys.findIndex((pk) => pk === key);

      return {
        key,
        order: priority === -1 ? 999 : priority,
        value,
      };
    })
    .sort((a, b) => a.value.groupName.localeCompare(b.value.groupName));

  return (
    <dl>
      {propertiesLoading && (
        <div className="mt-5 flex justify-center">
          <Loader2 className="animate-spin" />
        </div>
      )}
      {sortedAttributes.map((propertyItem) => (
        <DataItem
          propertiesOriginal={properties ?? []}
          key={propertyItem.value.id}
          propertyItem={propertyItem.value}
          attributesKeyTexts={attributesKeyTexts}
        />
      ))}
    </dl>
  );
}
